import React from "react"
import VideoPage from "../components/video-page"

const Tentakulum3Page = () => (
  <VideoPage title="TENTAKULUM 3" path="/video/tentakulum-3.{ext}" />
)

export default Tentakulum3Page
